import chevronUpBlackIcon from 'assets/img/chevron-up-black.svg'
import {
  AccordionContainer,
  Answered,
  ChevronIcon,
  CollapsibleContent,
  MetaValue,
  ObjectiveCard,
  ObjectiveHeader,
  ObjectiveTable,
  ObjectiveTableCell,
  ObjectiveTableHeadCell,
  ObjectiveTableRow,
  ObjectiveTitle,
  objectiveTableColumnWidths,
  SkeletonBlock,
  TableHeader,
  TablePanel,
  TableScrollContainer,
  ObjectiveDividerCell,
  ObjectiveDividerLine,
  ObjectiveDividerRow,
  ObjectiveSubtitle
} from './styles'
import { Fragment } from 'react'

const ObjectivesSkeleton = ({ type }: { type?: 'formative' | 'benchmark' }) => {
  return (
    <AccordionContainer>
      <ObjectiveCard key={`${type}-skeleton`} $expanded type={type}>
        {type === 'formative' && (
          <ObjectiveHeader type='button'>
            <ChevronIcon src={chevronUpBlackIcon} alt='Loading objective' />
            <ObjectiveTitle>
              <SkeletonBlock width='260px' height='20px' radius='50px' />
            </ObjectiveTitle>
          </ObjectiveHeader>
        )}
        <CollapsibleContent $expanded>
          {type === 'formative' && (
            <ObjectiveSubtitle style={{ marginLeft: 33 }}>
              <SkeletonBlock
                width='500px'
                height='20px'
                radius='50px'
                style={{ marginBottom: 10 }}
              />
            </ObjectiveSubtitle>
          )}

          <TableScrollContainer>
            <TableHeader>
              <ObjectiveTable>
                <colgroup>
                  {objectiveTableColumnWidths.map((width, index) => (
                    <col key={`head-col-${index}`} style={{ width }} />
                  ))}
                </colgroup>
                <thead>
                  <tr>
                    {/* <ObjectiveTableHeadCell $heading> */}
                    {type === 'benchmark' ? (
                      <ObjectiveTableHeadCell $heading>
                        {' '}
                        <ChevronIcon
                          style={{ marginRight: 12 }}
                          src={chevronUpBlackIcon}
                          alt='Loading objective'
                        />{' '}
                        Assessments
                      </ObjectiveTableHeadCell>
                    ) : (
                      <ObjectiveTableHeadCell />
                    )}
                    <ObjectiveTableHeadCell />
                    <ObjectiveTableHeadCell>
                      Questions Answered
                    </ObjectiveTableHeadCell>
                    <ObjectiveTableHeadCell>Score</ObjectiveTableHeadCell>
                    <ObjectiveTableHeadCell>
                      Time
                      <br />
                      Spent
                    </ObjectiveTableHeadCell>
                    <ObjectiveTableHeadCell>Action</ObjectiveTableHeadCell>
                  </tr>
                </thead>
              </ObjectiveTable>
            </TableHeader>
            <TablePanel>
              <ObjectiveTable>
                <colgroup>
                  {objectiveTableColumnWidths.map((width, index) => (
                    <col key={`body-col-${index}`} style={{ width }} />
                  ))}
                </colgroup>
                <tbody>
                  {(type === 'benchmark' ? [1, 2, 3] : [1, 2, 3, 4]).map(
                    (rowIndex) => (
                      <Fragment key={`formative-skeleton-row-${rowIndex}`}>
                        <ObjectiveTableRow $disabled>
                          <ObjectiveTableCell $alignStart>
                            <SkeletonBlock
                              width='200px'
                              height='12px'
                              radius='10px'
                            />
                          </ObjectiveTableCell>

                          <ObjectiveTableCell>
                            <div className='flex-col'>
                              <SkeletonBlock
                                width='66px'
                                height='12px'
                                radius='8px'
                              />
                              <SkeletonBlock
                                width='46px'
                                height='12px'
                                radius='8px'
                                style={{ marginTop: 5 }}
                              />
                            </div>
                          </ObjectiveTableCell>

                          <ObjectiveTableCell>
                            <Answered>
                              <SkeletonBlock
                                width='63px'
                                height='12px'
                                radius='999px'
                              />
                              <SkeletonBlock
                                width='26px'
                                height='12px'
                                radius='8px'
                              />
                            </Answered>
                          </ObjectiveTableCell>

                          <ObjectiveTableCell>
                            <MetaValue>
                              <div className='flex'>
                                <SkeletonBlock
                                  width='31px'
                                  height='18px'
                                  radius='10px'
                                />
                              </div>
                            </MetaValue>
                          </ObjectiveTableCell>
                          <ObjectiveTableCell>
                            <MetaValue>
                              <div className='flex'>
                                <SkeletonBlock
                                  width='31px'
                                  height='18px'
                                  radius='10px'
                                />
                              </div>
                            </MetaValue>
                          </ObjectiveTableCell>

                          <ObjectiveTableCell>
                            <div className='flex'>
                              <SkeletonBlock
                                width='80px'
                                height='32px'
                                radius='999px'
                              />
                            </div>
                          </ObjectiveTableCell>
                        </ObjectiveTableRow>
                        <ObjectiveDividerRow>
                          <ObjectiveDividerCell colSpan={6}>
                            <ObjectiveDividerLine />
                          </ObjectiveDividerCell>
                        </ObjectiveDividerRow>
                      </Fragment>
                    )
                  )}
                </tbody>
              </ObjectiveTable>
            </TablePanel>
          </TableScrollContainer>
        </CollapsibleContent>
      </ObjectiveCard>
    </AccordionContainer>
  )
}

export default ObjectivesSkeleton
